// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__rghbu"};